module.exports = __webpack_public_path__ + "dj.0a5d2521afe600cc72b8.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/dj.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/dj.svg
// module chunks = styles